var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffcdff;}.cls-1,.cls-2{stroke:#fff;stroke-miterlimit:10;stroke-width:4.46px;}.cls-1,.cls-2,.cls-3,.cls-4{fill-rule:evenodd;}.cls-2{fill:#ffe6ff;}.cls-5{fill:none;stroke:#47006f;stroke-linecap:round;stroke-linejoin:round;stroke-width:16.12px;}.cls-3{fill:#ff0051;}.cls-3,.cls-4,.cls-6{stroke-width:0px;}.cls-4{fill:#ff85b1;}.cls-6{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3981",
    className: "cls-1",
    d: "m199.64,166.22l140.05,115.04,78.27-159.44c3.58-7.27,4.21-15.55-2.01-20.69l-54.45-44.69c-6.23-5.14-14.24-2.9-20.67,2.02l-141.18,107.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3985",
    className: "cls-2",
    d: "m242.77,271.02l70.37,57.78,15.69,12.91,18.27-22.26c9.46-11.52,7.79-28.71-3.73-38.17l-.05-.02-140.05-115.04-.05-.02c-11.52-9.46-28.71-7.79-38.17,3.74l-18.27,22.26,15.71,12.91,80.28,65.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3989",
    className: "cls-4",
    d: "m123.05,284.86c9.12,0,16.59,7.45,16.59,16.57v11.64c0,9.12,7.45,16.6,16.57,16.6s16.6-7.49,16.6-16.6v-3.67c0-9.1,7.45-16.57,16.57-16.57s16.6,7.45,16.6,16.57v11.61c0,9.12,7.47,16.6,16.6,16.6s16.57-7.47,16.57-16.6v-49.99l-80.28-65.93c-10.73,6.11-20.56,14.26-28.87,24.38-17.27,21.01-24.93,46.78-23.55,71.95,0-9.12,7.47-16.57,16.59-16.57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3993",
    className: "cls-3",
    d: "m70.11,413.28h69.84c-9.12,0-16.6,7.47-16.6,16.6s7.47,16.62,16.6,16.62h191.45c9.15,0,16.62-7.49,16.62-16.62s-7.47-16.6-16.62-16.6h98.46c9.15,0,16.62-7.47,16.62-16.62s-7.47-16.6-16.62-16.6h-157.96c7.02-5.12,13.52-11.18,19.29-18.2,8.31-10.12,14.38-21.33,18.32-33.06l-70.37-57.78v49.99c0,9.12-7.45,16.6-16.57,16.6s-16.59-7.47-16.59-16.6v-11.61c0-9.12-7.47-16.57-16.6-16.57s-16.57,7.47-16.57,16.57v3.67c0,9.1-7.47,16.6-16.59,16.6s-16.57-7.47-16.57-16.6v-11.64c0-9.12-7.47-16.57-16.59-16.57s-16.6,7.45-16.6,16.57c1.58,28.12,14.47,55.54,37.94,74.83,1.61,1.31,3.26,2.58,4.91,3.8h-79.19c-9.12,0-16.6,7.47-16.6,16.6s7.47,16.62,16.6,16.62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3997",
    className: "cls-5",
    d: "m228.03,375.49v8.2c0,9.01-7.38,16.39-16.39,16.39s-16.41-7.38-16.41-16.39v-8.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4001",
    className: "cls-5",
    d: "m143.15,192.19l182.05,149.52,18.27-22.26c9.46-11.52,7.79-28.71-3.74-38.17l-140.14-115.08c-11.52-9.46-28.71-7.79-38.17,3.74l-18.27,22.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4005",
    className: "cls-5",
    d: "m271.56,446.49h59.84c9.15,0,16.62-7.49,16.62-16.62s-7.47-16.6-16.62-16.6h98.46c9.15,0,16.62-7.47,16.62-16.62s-7.47-16.6-16.62-16.6h-157.96c7.02-5.12,13.52-11.18,19.29-18.2,8.31-10.12,14.38-21.33,18.32-33.06m-150.65-123.71c-10.73,6.11-20.56,14.26-28.87,24.38-36.56,44.51-30.11,110.21,14.4,146.78,1.61,1.31,3.26,2.58,4.91,3.8h-79.19c-9.12,0-16.6,7.47-16.6,16.6s7.47,16.62,16.6,16.62h69.84c-9.12,0-16.6,7.47-16.6,16.6,0,9.12,7.47,16.62,16.6,16.62h59.86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4009",
    className: "cls-5",
    d: "m317.84,76l22.35,18.34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4013",
    className: "cls-5",
    d: "m282.88,102.69l36.09,29.66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4017",
    className: "cls-5",
    d: "m247.91,129.41l54.47,44.74"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4021",
    className: "cls-5",
    d: "m239.14,271.02v49.99c0,9.12-7.45,16.6-16.57,16.6s-16.59-7.47-16.59-16.6v-11.62c0-9.12-7.47-16.57-16.6-16.57s-16.57,7.47-16.57,16.57v3.67c0,9.1-7.47,16.6-16.59,16.6s-16.57-7.47-16.57-16.6v-11.64c0-9.12-7.47-16.57-16.6-16.57s-16.59,7.45-16.59,16.57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4025",
    className: "cls-5",
    d: "m339.69,281.26l78.27-159.44c3.58-7.27,4.21-15.55-2.01-20.69l-54.45-44.69c-6.23-5.14-14.24-2.9-20.67,2.02l-141.18,107.77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4027"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4029",
    className: "cls-5",
    d: "m235.73,446.49h-.05"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.ef5c6cb423150a93ee5c82cb89e116b5.svg";
export { ForwardRef as ReactComponent };